import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  DxButtonComponent,
  DxFileUploaderComponent,
  DxTextBoxComponent,
  DxValidatorComponent,
} from 'devextreme-angular';
import { DxiValidationRuleComponent } from 'devextreme-angular/ui/nested';
import notify from 'devextreme/ui/notify';
import { Articoli } from 'src/app/models/articoli';
import { AllegatiArticoliService } from 'src/app/shared/services/allegati-articoli.service';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { NavigatorService } from 'src/app/shared/services/navigator.service';

@Component({
  selector: 'app-new-allegato-articoli',
  templateUrl: './new-allegato-articoli.component.html',
  imports: [
    DxFileUploaderComponent,
    DxButtonComponent,
    DxTextBoxComponent,
    DxValidatorComponent,
    DxiValidationRuleComponent
  ],
  standalone: true,
})
export class NewAllegatoArticoliComponent implements OnInit {
  private articoliS = inject(ArticoliService);
  private allS = inject(AllegatiArticoliService);
  private route = inject(ActivatedRoute);
  private nS = inject(NavigatorService);

  articoli: Articoli;
  idArticolo: number;
  value: any[] = [];
  nomeAllegato = '';

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.idArticolo = +params.get('idArticolo');
      console.log(this.idArticolo + ' idArticolo ricevuto');
      //this.urlValue = this.urlBase + '?idDpi=' + this.idDpi;
      this.articoliS.get(this.idArticolo).subscribe((dati) => {
        this.articoli = dati;
      });
    });
  }
  getSelectedFiles() {
    return this.value;
  }

  allegaFile(e, files) {
    const result = e.validationGroup.validate();
    if (result.isValid) {
      const formData = new FormData();
      formData.append('file', files[0]);
      this.allS
        .allega(this.idArticolo, this.nomeAllegato, formData)
        .subscribe((dati) => {
          console.log('Allegato inserito id: ' + dati);
          notify({ message: 'Allegato salvato', width: 300, shading: true });
          this.nS.goToArticoli();
        });
    }
  }
}

